module.exports = __webpack_public_path__ + "static/media/210옴니고딕020.ae16b207.ttf";